import React from 'react';
import { motion } from 'framer-motion';
import { FiCheckCircle } from 'react-icons/fi';

const About = () => {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          
          {/* Image Side */}
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:w-1/2 relative"
          >
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="/assets/images/about.jpg" 
                alt="Logistics Operations" 
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-brand-black/20"></div>
            </div>
            
          </motion.div>

          {/* Content Side */}
          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:w-1/2"
          >
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-1 bg-brand-red"></div>
              <h4 className="text-brand-red font-bold uppercase tracking-widest text-sm">Tentang Kami</h4>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold mb-6 text-brand-black leading-tight">
              Membangun Konektivitas, <br/> Menggerakkan Ekonomi.
            </h2>
            <p className="text-gray-600 mb-6 text-lg leading-relaxed">
              <strong className="text-brand-black">Tanjungprioklogistik.com</strong> lahir dari semangat untuk menyederhanakan rantai pasok di era digital. Berbasis di pusat nadi logistik Indonesia, kami memahami bahwa ketepatan waktu bukan sekadar target, melainkan sebuah janji.
            </p>
            <p className="text-gray-600 mb-8 text-lg leading-relaxed">
              Sebagai mitra logistik terpercaya, kami menggabungkan infrastruktur armada yang kuat dengan manajemen operasional yang modern. Kami melayani berbagai skala bisnis—mulai dari kebutuhan kurir instan, pendistribusian barang retail melalui jalur darat dan laut, hingga pengiriman alat berat dan ekspor-impor skala global. Fokus kami adalah memberikan ketenangan bagi setiap klien bahwa aset mereka berada di tangan yang tepat.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {['Infrastruktur Kuat', 'Operasional Modern', 'Skala Global & Lokal', 'Fokus Keamanan'].map((item, idx) => (
                <div key={idx} className="flex items-center gap-3">
                  <FiCheckCircle className="text-brand-red flex-shrink-0" size={20} />
                  <span className="font-semibold text-brand-black">{item}</span>
                </div>
              ))}
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default About;